import React from "react";
import PropTypes from "prop-types";
import { Text, Paragraph } from "components/core/Typography";
import formatUSD from "utils/formatUSD";

import "./NearbyFacilitiesUnits.scss";
import { FacilityPageSection } from "../FacilityPageSection";

const NearbyUnitCard = ({ lowestPrice, sizeText, url }) => (
	<div className="nearby-unit-card">
		<Paragraph
			size="medium"
			weight="bold"
			last
		>
			{sizeText}
		</Paragraph>
		<div className="nearby-unit-card-price">
			<Text
				size="small"
				last
			>
				Starting at
			</Text>
			<Text
				size="large"
				weight="bold"
				color="green"
				last
			>
				{formatUSD(lowestPrice)}
			</Text>
			<Text
				size="small"
				color="lightGray"
				last
			>
				per month
			</Text>
		</div>
		<Paragraph
			className="nearby-unit-card-link"
			size="standard"
			weight="semiBold"
			last
		>
			<a href={url}>See More in Your Area</a>
		</Paragraph>
	</div>
);
NearbyUnitCard.propTypes = {
	sizeText: PropTypes.string,
	url: PropTypes.string,
	lowestPrice: PropTypes.number
};

const NearbyFacilitiesUnits = ({ units }) => (
	<FacilityPageSection
		className="nearby-units-section"
		title="Units Available At Nearby Facilities"
		isCollapsable={false}
		defaultOpen
		autoHeight
	>
		<div className="nearby-unit-cards">
			{units.map(({ id, lowestPrice, sizeText, url }) => (
				<NearbyUnitCard
					key={id}
					{...{ lowestPrice, sizeText, url }}
				/>
			))}
		</div>
	</FacilityPageSection>
);

NearbyFacilitiesUnits.propTypes = {
	units: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			lowestPrice: PropTypes.number,
			sizeText: PropTypes.string,
			url: PropTypes.string
		})
	)
};

export default NearbyFacilitiesUnits;
